import styled from "styled-components";

export const Container = styled.div`
  padding: 50px;
  display: flex;

  .imageWrapper {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .contentWrapper {
    width: 100%;
    margin-left: 42px;

    .avisoLimiteObras {
      width: auto;
      font-size: 12px;
      font-weight: 600;
      border-radius: 25px;
      border: 2px solid ${({ theme }) => theme.colors.danger.danger};
      color: ${({ theme }) => theme.colors.danger.danger};
      padding: 8px 18px;
    }

    h2 {
      font-size: 22px;
      font-weight: 700;
      line-height: 33px;
      color: ${({ theme }) => theme.colors.surface.onSurface};
      margin-top: 32px;
    }

    h3 {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
      margin-top: 6px;
    }

    p {
      font-size: 12px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
      margin-top: 30px;
      margin-bottom: 0;
    }

    .icons-wrapper {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
      
      .icons-text-margin {
        margin-right: 23px;
      }

      .icons-text-wrapper {
        div {
          display: flex;
          align-items: center;
          
          &+div {
            margin-top: 16px;
          }

          i {
            margin-right: 12px;
          }

          span {
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
            color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
          }
        }

        .icons-text-wrapper-icon {
          color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
        }
      }
    }

    .button-wrapper{
      display: flex;
      margin-top: 48px;

      .button-cancel {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        line-height: 16px;

        &+.button-cancel {
          margin-left: 10px;
        }
      }

      .button-confirm {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.surface.onSurface};
        margin-left: 10px;

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 12px;
          margin-bottom: 0;
        }
      }
    }
  }

  .contentWrapperPro {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
